// Talep akışının searchParams anahtarları, sıralı. Bir adım seçilince
// kendisinden sonraki anahtarlar temizlenir.
export const STEP_PARAMS = [
  'category',
  'brand',
  'series',
  'model',
  'type',
] as const;

export type StepParam = (typeof STEP_PARAMS)[number];

/**
 * Adım şeridindeki bir kutu. `param`, adımın URL'de karşılık geldiği anahtar;
 * son adımın (Onay) parametresi yoktur.
 *
 * Etiket ile parametreyi aynı yerde tutmak şart: serisi tanımsız markalarda
 * "Seri" adımı listeden düşüyor, geri gitme mantığı da bunu görmeli.
 */
export type StepLabel = {
  label: string;
  description: string;
  param?: StepParam;
};

// Tam adım seti. Seri adımı yalnızca markanın serisi varsa gösterilir;
// yoksa server (page.tsx) bu adımı listeden çıkarır.
//
// Adımlar yalnızca cihaz/arıza seçimini kapsar. Son adım tek bir ödeme sayfası:
// cihaz bilgileri, kargo adresi, randevu günü ve "Öde ve Gönder" aynı ekranda —
// backend'e de tek POST gider, adım adım kayıt yok.
export const STEP_LABELS: StepLabel[] = [
  { label: 'Ürün', description: 'Cihaz türü', param: 'category' },
  { label: 'Marka', description: 'Marka seç', param: 'brand' },
  { label: 'Seri', description: 'Seri seç', param: 'series' },
  { label: 'Model', description: 'Model seç', param: 'model' },
  { label: 'Arıza', description: 'Sorun seç', param: 'type' },
  { label: 'Onay', description: 'Adres ve ödeme' },
];

// Seri adımı olmadan (markanın serisi tanımsız) kullanılacak etiketler.
export const STEP_LABELS_NO_SERIES: StepLabel[] = STEP_LABELS.filter(
  (s) => s.param !== 'series'
);

/**
 * Arama kutusunun görüneceği eşik; birkaç seçenek varken kutu yer kaplamasın.
 * Marka/seri/model adımları ve arıza adımı aynı değeri kullanır.
 */
export const SEARCH_THRESHOLD = 8;

/** Adım içeriğinin başlık metinleri ve (varsa) arama kutusu yer tutucusu. */
export const STEP_CONTENT: Record<
  StepParam,
  { title: string; description: string; searchPlaceholder?: string }
> = {
  category: {
    title: 'Hangi cihazı tamir ettirmek istiyorsunuz?',
    description:
      'Cihazınızı seçin, size özel arıza seçeneklerini ve ön teklif fiyatlarını gösterelim.',
  },
  brand: {
    title: 'Marka seçin',
    description: 'Cihazınızın markasını seçin.',
    searchPlaceholder: 'Marka ara…',
  },
  series: {
    title: 'Seri seçin',
    description: 'Cihazınızın serisini seçin.',
    searchPlaceholder: 'Seri ara…',
  },
  model: {
    title: 'Model seçin',
    description: 'Cihazınızın modelini seçin.',
    searchPlaceholder: 'Model ara…',
  },
  type: {
    title: 'Cihazınızdaki sorunu seçin.',
    description:
      'Birden fazla arıza seçebilirsiniz. Gösterilen tutarlar ön tekliftir; cihazınız incelendikten sonra kesinleşir.',
    searchPlaceholder: 'Arıza ara…',
  },
};
